
<modal :state="state" :index="index" @toggle-modal="reset">
  <scroll-area>

    <h3 class="modal-title">Model Properties</h3>
    <row>
      <strong>Id</strong>: {{ objectModelEntry.id }}
    </row>
    <row v-for="property in objectModelProperties" v-bind:key="property.client_id">
      <strong>{{ property.label_title }}</strong>: {{ displayProperty(property) }}
    </row>
    <div class="cta align-center">
      <button type="button" @click="reset" class="btn green">Close</button>
    </div>
  </scroll-area>

</modal>

